import { render } from "./App.vue?vue&type=template&id=1b34ea74"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1b34ea74&lang=scss"

import exportComponent from "C:\\Users\\hechque\\WebstormProjects\\2022-PO-MSC-CSS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__